<template>
  <div class="container">
    <div class="row align-content-center justify-content-center text-center px-3">
      <m-icon icon="arrow-right-circle" class="cursor-pointer h4" :class="{'d-none':previewsDayButtonStatus()}"
              @click="changeSelectedMonth('down')"/>
      <div class="col">{{ currentDateString() }}</div>
      <m-icon icon="arrow-left-circle" class="cursor-pointer h4" @click="changeSelectedMonth('up')"/>
    </div>
  </div>
</template>

<script>
import mIcon from "../../Icons/Icon.vue";

export default {
  name: "ReservationDaySelector",
  components: {mIcon},
  data() {
    return {
      currentDate: new Date()
    }
  },
  computed: {},
  methods: {
    changeSelectedMonth(mode = 'up') {
      if (mode === 'up') {
        this.currentDate.setDate(this.currentDate.getDate() + 1)
        this.emitCurrentDate();
      }
      if (mode === 'down') {
        this.currentDate.setDate(this.currentDate.getDate() - 1)
        this.emitCurrentDate();
      }
      this.$forceUpdate()
    },
    currentDateString() {
      return this.currentDate.toLocaleDateString('fa-IR-u-nu-latn', {weekday: 'long', day: 'numeric', month: 'short'})
    },
    emitCurrentDate() {
      this.$emit('day', this.currentDate)
    },
    previewsDayButtonStatus() {
      const selectedDate = this.currentDate.toLocaleString('en-us', {year: "numeric", month: 'numeric', day: "2-digit"})
      const currentDate = new Date().toLocaleString('en-us', {year: "numeric", month: 'numeric', day: "2-digit"})
      return (selectedDate === currentDate)
    }
  },
  mounted() {

  }
}
</script>


<style scoped>

</style>